import { IconName, IconPrefix } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIconProps } from '@fortawesome/react-fontawesome';

type FileIconItem = {
  [key: string]: {
    icon: string;
    iconStyle: string;
    color: string;
  };
};

const fileTypes: FileIconItem = {
  filePdf: { icon: 'file-pdf', iconStyle: 'fad', color: 'red' },
  fileWord: { icon: 'file-word', iconStyle: 'fad', color: 'blue' },
  filePowerpoint: {
    icon: 'file-powerpoint',
    iconStyle: 'fad',
    color: 'yellow',
  },
  fileSpreadsheet: {
    icon: 'file-spreadsheet',
    iconStyle: 'fad',
    color: 'green',
  },
  fileImage: { icon: 'file-image', iconStyle: 'fad', color: 'blue' },
  fileVideo: { icon: 'file-video', iconStyle: 'fad', color: 'red' },
  fileArchive: { icon: 'file-archive', iconStyle: 'fad', color: 'darkGray' },
  fileCsv: { icon: 'file-csv', iconStyle: 'fad', color: 'green' },
  fileText: { icon: 'file-alt', iconStyle: 'fad', color: 'darkGray' },
};

export const fileIcons: FileIconItem = {
  pdf: fileTypes.filePdf,
  docx: fileTypes.fileWord,
  doc: fileTypes.fileWord,
  ppt: fileTypes.filePowerpoint,
  pptX: fileTypes.filePowerpoint,
  xls: fileTypes.fileSpreadsheet,
  xlsx: fileTypes.fileSpreadsheet,
  jpeg: fileTypes.fileImage,
  jpg: fileTypes.fileImage,
  png: fileTypes.fileImage,
  gif: fileTypes.fileImage,
  tiff: fileTypes.fileImage,
  raw: fileTypes.fileImage,
  mp4: fileTypes.fileVideo,
  m4a: fileTypes.fileVideo,
  m4v: fileTypes.fileVideo,
  f4v: fileTypes.fileVideo,
  f4a: fileTypes.fileVideo,
  m4b: fileTypes.fileVideo,
  m4r: fileTypes.fileVideo,
  f4b: fileTypes.fileVideo,
  mov: fileTypes.fileVideo,
  '3gp': fileTypes.fileVideo,
  '3gp2': fileTypes.fileVideo,
  '3g2': fileTypes.fileVideo,
  '3gpp': fileTypes.fileVideo,
  '3gpp2': fileTypes.fileVideo,
  ogg: fileTypes.fileVideo,
  oga: fileTypes.fileVideo,
  ogv: fileTypes.fileVideo,
  ogx: fileTypes.fileVideo,
  wmv: fileTypes.fileVideo,
  wma: fileTypes.fileVideo,
  flv: fileTypes.fileVideo,
  avi: fileTypes.fileVideo,
  quicktime: fileTypes.fileVideo,
  zip: fileTypes.fileArchive,
  rar: fileTypes.fileArchive,
  gz: fileTypes.fileArchive,
  '7z': fileTypes.fileArchive,
  'tar.gz': fileTypes.fileArchive,
  csv: fileTypes.fileCsv,
  txt: fileTypes.fileText,
  default: { icon: 'file', iconStyle: 'fad', color: '' },
};
